import { FC, useEffect, useState } from 'react';
import { Card, Statistic, Spin, Row, Col } from 'antd';
import { fetchRealTimePrice, RealTimePrice } from '../../api/priceOffset';
import TimeDisplay from '../TimeDisplay';

interface RealTimePriceMonitorProps {
  productCode?: string;
}

const RealTimePriceMonitor: FC<RealTimePriceMonitorProps> = ({ productCode }) => {
  const [priceData, setPriceData] = useState<RealTimePrice | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 重置状态
    if (!productCode) {
      setPriceData(null);
      setError(null);
      return;
    }

    let intervalId: NodeJS.Timeout;
    
    const fetchPrice = async () => {
      setLoading(true);
      try {
        const data = await fetchRealTimePrice(productCode);
        setPriceData(data);
        setError(null);
      } catch (err) {
        console.error('获取实时价格失败', err);
        setError('获取实时价格失败');
      } finally {
        setLoading(false);
      }
    };

    // 立即获取一次
    fetchPrice();
    
    // 每秒更新一次
    intervalId = setInterval(fetchPrice, 1000);
    
    // 清理函数
    return () => {
      clearInterval(intervalId);
    };
  }, [productCode]);

  if (!productCode) {
    return (
      <Card title="实时价格监控" style={{ marginBottom: 16 }} variant="borderless">
        <div>请选择产品</div>
      </Card>
    );
  }

  return (
    <Card title="实时价格监控" style={{ marginBottom: 16 }} variant="borderless">
      {loading && !priceData ? (
        <Spin />
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : priceData ? (
        <div>
          <Row gutter={16}>
            <Col span={12}>
              <Statistic 
                title="控盘价格" 
                value={priceData.controlPrice || 0} 
                precision={4} 
                style={{ marginBottom: 16 }}
              />
            </Col>
            <Col span={12}>
              <Statistic 
                title="盘口价格" 
                value={priceData.price || 0} 
                precision={4} 
                style={{ marginBottom: 16 }}
              />
            </Col>
          </Row>
          <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>
            更新时间: {priceData.timestamp ? (
              <TimeDisplay 
                value={priceData.timestamp} 
                style={{ fontSize: 12, color: '#999' }}
              />
            ) : '--:--:--'}
          </div>
        </div>
      ) : (
        <div>暂无数据</div>
      )}
    </Card>
  );
};

export default RealTimePriceMonitor; 